import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-homepage-icons',
  templateUrl: './homepage-icons.component.html',
  styleUrls: ['./homepage-icons.component.css']
})
export class HomepageIconsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/homepage/homepage-icons/homepage-icons.component.ts